import React from "react";
import emailjs from "emailjs-com";
import { Checkmark } from "react-checkmark";
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

/* The booking and cancellation pages are the same form with different wording,
   so they share this component and differ only in the copy below. */
const EFNI = {
	bokun: {
		title: "Bóka tíma",
		lead: "",
		intro: "Hægt er að óska eftir tíma hjá sjúkraþjálfara Atlas með eftirfarandi hætti:",
		outro:
			"Við höfum samband við þig eins fljótt og hægt er til að staðfesta tíma.",
		formTitle: "Ósk um tíma",
	},
	afbokun: {
		title: "Afbókun tíma",
		lead: "Vinsamlegast afboðið bókaðan tíma hjá sjúkraþjálfara með minnst 2 klukkustunda fyrirvara. Berist afboð síðar er innheimt 7.000 kr. forfallagjald.",
		intro: "Hægt er að afboða tíma með því að:",
		outro:
			"Athugið að viðskiptavinir bera ábyrgð á bókuðum tímum og Sjúkratryggingar Íslands greiða ekki fyrir tíma sem ekki er mætt í.",
		formTitle: "Afboka tíma",
	},
};

function TimaForm({ mode }) {
	const efni = EFNI[mode] || EFNI.afbokun;

	function sendEmail(e) {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_jfu0opb",
				"template_752mj4b",
				e.target,
				"user_DSn71ERKhbLwj3njTVFsJ"
			)
			.then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);
		e.target.reset();
		document.getElementById("checkMarkPos").style.display = "inline";
	}

	const emailTab = (url) => {
		const newWindow = window.open(url, "_blank", "noopener,noreferrer");
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div className="Body">
			<div className="TimaPage">
				<div className="Title">
					<h1> {efni.title} </h1>
				</div>

				<div className="toggleGroup">
					<NavLink
						end
						to="/timabokun"
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Ósk um tíma
					</NavLink>
					<NavLink
						end
						to="/afbokun"
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Afboka tíma
					</NavLink>
				</div>

				<div className="TimaIntro">
					{efni.lead && <p>{efni.lead}</p>}
					<h4>{efni.intro}</h4>
					<ul>
						<li>Fylla út formið hér fyrir neðan</li>
						<li>
							Senda tölvupóst á{" "}
							<span
								className="HafaSambandLinkur"
								onClick={() =>
									emailTab("mailto:afgreidsla@atlasendurhaefing.is")
								}
							>
								afgreidsla@atlasendurhaefing.is
							</span>
						</li>
						<li>Hringja í síma 552 6600</li>
					</ul>
					<p>{efni.outro}</p>
				</div>

				<form onSubmit={sendEmail}>
					<input type="hidden" name="formType" value={efni.formTitle} />

					<div className="form">
						<input type="text" id="name" name="name" maxLength="50" required />
						<label htmlFor="name" className="label-field">
							<span className="content-name"> Nafn </span>
						</label>
					</div>

					<div className="form">
						<input
							type="text"
							id="ssn"
							name="ssn"
							onKeyPress={(event) => {
								if (!/[0-9]/.test(event.key)) {
									event.preventDefault();
								}
							}}
							maxLength="10"
							required
						/>
						<label htmlFor="ssn" className="label-field">
							<span className="content-name"> Kennitala </span>
						</label>
					</div>

					<div className="form">
						<input type="text" id="email" name="email" maxLength="100" required />
						<label htmlFor="email" className="label-field">
							<span className="content-name"> Netfang </span>
						</label>
					</div>

					<div className="form">
						<input
							type="text"
							id="phone"
							name="phone"
							onKeyPress={(event) => {
								if (!/[0-9]/.test(event.key)) {
									event.preventDefault();
								}
							}}
							maxLength="50"
							required
						/>
						<label htmlFor="phone" className="label-field">
							<span className="content-name"> Sími </span>
						</label>
					</div>

					<div className="form-large">
						<textarea
							id="message"
							className="skilabod"
							name="message"
							maxLength="800"
							required
						/>
						<label htmlFor="message" className="label-field">
							<span className="content-name"> Skilaboð </span>
						</label>
					</div>

					<div className="btn-div">
						<button type="submit" className="btn btn-border-pop">
							Senda skilaboð
						</button>
						<div id="checkMarkPos">
							<Checkmark size="30px" />
							<div className="messageRecived"> Móttekið </div>
						</div>
					</div>
				</form>
			</div>

			<div className="TimaImage">
				<LazyLoadImage
					src={
						"https://res.cloudinary.com/atlasendurhaefing/image/upload/v1692110499/atlas2.0/images/mottaka_im0ft2.jpg"
					}
					alt="Móttaka í Atlas endurhæfingu"
					effect="blur"
				/>
			</div>
		</div>
	);
}

export default TimaForm;
